import Select from 'react-select'
import { FormActionKind } from './formReducer'
import { useFormEngineContext } from './formContext'
import { useFieldContext } from './fieldInstanceContext'
import { FoundationsConstants } from '../../FoundationsConstants'
import { useSelector } from 'react-redux'
import { getCurrentUserData, RootState } from '../../Redux/store'
// This component is the widgets (inputs, selects, etc) that can be used to set fields on a form before submitting

export const Mselect2Config = (
    multiple: any,
    optionsList: any,
    onChange: any,
    selectedValuesProp: any,
    style: { [s: string]: any },
    id: any
) => {
    return {
        multiple: multiple,
        optionsList: optionsList,
        onChange: onChange,
        selectedValuesProp: selectedValuesProp,
        style: style,
        id: id,
    }
}

export const MultiSelect = function (props: {
    multiple: any
    id: string
    optionsList: any[]
    selectedValuesProp: any[]
    style: any
    field: { [s: string]: any }
    setIndex: number
    fieldIndex?: number
}) {
    const { multiple, id, optionsList, selectedValuesProp, style, field, setIndex, fieldIndex } =
        props
    const { formState } = useFormEngineContext()
    const { fieldState, fieldDispatch } = useFieldContext()
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))

    const getDataForMultiSelectFields = () => {
        let multiSelectMap = {} as { [s: string]: any }
        var schemaInstances = formState.schema.sections[0].instances[0].fields
        let schemaWithLists = schemaInstances.filter(function (instance: { type: string }) {
            return (
                instance.type == 'single-select-dropdown' ||
                instance.type == 'multi-select-dropdown'
            )
        })
        schemaWithLists.forEach(function (list: any, idx: string | number) {
            if (typeof schemaWithLists[idx].domain == 'string')
                // Modify this later to check on radio/checkbox/dropdown
                schemaWithLists[idx].domain = JSON.parse(schemaWithLists[idx].domain)
            multiSelectMap[schemaWithLists[idx].id] = schemaWithLists[idx].domain
        })
        return multiSelectMap
    }
    //    TODO !! add select2 here
    if (multiple !== undefined && id !== undefined && optionsList !== undefined) {
        const multiSelectMap = getDataForMultiSelectFields()
        const selectOptions = [
            { value: '', label: '' },
            ...optionsList.map((item) => {
                return { value: item.value, label: item.value }
            }),
        ]
        return (
            <Select
                id={'select_' + id}
                isMulti={multiple}
                isDisabled={formState.isReadOnly}
                menuPortalTarget={document.querySelector('body')}
                value={
                    multiple
                        ? selectedValuesProp.map((item) => {
                              return { value: item.value, label: item.value }
                          })
                        : ({
                              label: selectedValuesProp[0]?.value,
                              value: selectedValuesProp[0]?.value,
                          } as any)
                }
                options={selectOptions}
                styles={{
                    container: (base, state) => ({
                        ...base,
                        background: 'inherit',
                    }),
                    control: (base, state) => ({
                        ...base,
                        background: 'inherit',
                    }),
                    group: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    input: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    menu: (base, state) => ({
                        ...base,
                        background:
                            currentUserData?.DisplayMode === FoundationsConstants.DisplayMode.Night
                                ? '#495057'
                                : 'inherit',
                        color:
                            currentUserData?.DisplayMode === FoundationsConstants.DisplayMode.Night
                                ? ' #eee'
                                : 'inherit',
                    }),
                    menuList: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    menuPortal: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    multiValue: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    multiValueLabel: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    multiValueRemove: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    option: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    singleValue: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                    valueContainer: (base, state) => ({
                        ...base,
                        background: 'inherit',
                        color: 'inherit',
                    }),
                }}
                onChange={(e) => {
                    const value = multiple ? e.map((val: any) => val.value) : [e.value]
                    const mapVar = value.map(function (vv: any) {
                        var num = -2
                        multiSelectMap[field.id].forEach(function (vs: {
                            value: any
                            key: number
                        }) {
                            if (vs.value === vv.value) num = vs.key
                        })
                        return num
                    })

                    if (fieldIndex !== undefined) {
                        fieldDispatch({
                            type: FormActionKind.updateFieldInstance,
                            payload: {
                                newValue: value,
                                fieldId: field.id,
                                setIndex: setIndex,
                                fieldIndex: fieldIndex,
                                attribute: 'fieldValue',
                            },
                        })
                        fieldDispatch({
                            type: FormActionKind.updateFieldInstance,
                            payload: {
                                newValue: mapVar,
                                fieldId: field.id,
                                setIndex: setIndex,
                                fieldIndex: fieldIndex,
                                attribute: 'fieldIndex',
                            },
                        })
                    } else {
                        console.error('Field index not provided for multi select')
                    }
                }}
            />
        )
    } else {
        var firstoption = { value: '', selected: true }
        return (
            <select
                id="select_undefined"
                style={{ fontSize: '10px', width: '260px' }}
                disabled={formState.isReadOnly}
            >
                <option {...firstoption}></option>
            </select>
        )
    }
}
